module.exports = __webpack_public_path__ + "static/media/flyer-2011.cd5fb780.pdf";